
import { Rectangle }   from './rectangle';
import { Text }        from './text';
import { Circle }      from './circle';
import { Line }        from './line';
import { FontWeight }  from '@/helpers/fonts/font.weight';
import { FontVariant } from '@/helpers/fonts/font.variant';
import { FontStyle }   from '@/helpers/fonts/font.style';


/**
 *
 * @class VisualFactory
 *
 * visuals builder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export class VisualFactory {

  /** build a line from the given parameters */
  public static buildCircle(item: Partial<Circle>): Circle {

    let visual: Circle = {
      isCircle: (): boolean => true,
      x:                0,
      y:                0,
      radius:           10,
      backgroundColor: 'white',
      borderColor:     'black',
      borderWidth:     1,
      visible:         true,
      opacity:         1.0
    };

    /* override with whatever they gave us */

    Object.assign(visual, item);

    /* pass it back */

    return visual;
  }

  /** build a line from the given parameters */
  public static buildLine(item: Partial<Line>): Line {

    let visual: Line = {
      isLine: (): boolean => true,
      x:         0,
      y:         0,
      points:    [{x: 0, y: 0}],
      color:     'white',
      lineWidth: 2,
      visible:   true,
      opacity:   1.0,
      lineCap:   'square'
    };

    /* override with whatever they gave us */

    Object.assign(visual, item);

    /* pass it back */

    return visual;
  }

  /** build some text from the given parameters */
  public static buildText(item: Partial<Text>): Text {

    let visual: Text = {
      isText: (): boolean => true,
      x:         0,
      y:         0,
      text:      'XO',
      family:    'Arial',
      size:      10,
      weight:    FontWeight.NORMAL,
      variation: FontVariant.NORMAL,
      style:     FontStyle.NORMAL,
      visible:   true,
      opacity:   1.0,
      rotation:  0
    };

    /* override with whatever they gave us */

    Object.assign(visual, item);

    /* pass it back */

    return visual;
  }

  /** build a rectangle from the given parameters */
  public static buildRectangle(item: Partial<Rectangle>): Rectangle {

    let visual: Rectangle = {
      isRectangle: (): boolean => true,
      x:               0,
      y:               0,
      width:           10,
      height:          10,
      cornerRadius:    0,
      backgroundColor: 'black',
      borderColor:     'white',
      borderWidth:     1,
      visible:         true,
      opacity:         1.0
    };

    /* override with whatever they gave us */

    Object.assign(visual, item);

    /* pass it back */

    return visual;
  }
}
